




















import Vue from 'vue';
import { Validation } from 'expangine-runtime';
import { ValidationHelper } from './ValidationHelper';
import { Registry } from '../runtime/Registry';


export default Vue.extend({
  props: {
    validation: {
      type: Object as () => Validation,
    },
    registry: {
      type: Object as () => Registry,
    },
  },
  computed: {
    icon(): string {
      return ValidationHelper.ICONS[this.validation.severity];
    },
    iconColor(): string {
      return ValidationHelper.COLORS[this.validation.severity];
    },
    exprName(): string {
      return this.validation.subject
        ? this.registry.getExpressionName(this.validation.subject)
        : this.validation.parent
          ? this.registry.getExpressionName(this.validation.parent)
          : '';
    },
    exprDescribe(): string {
      return ValidationHelper.getDescription(this.validation, this.registry);
    },
  },
  methods: {
    enter() {
      this.$emit('hover', this.validation);
    },
    exit() {
      this.$emit('hover', null);
    },
  },
});
